import React from 'react';
import {useSelector} from "react-redux";
import ClayMd from "components/ClaySizeCategory/ClayMd/ClayMd";
import PaletListMdPrettier from "./paletListMdPrettier";

const PaletListMd = ({ category, data, onClickHandle }) => {
  const baseUrl = useSelector(state => state.Feature.imageBaseUrl);

  // Deduplicate by color_name - show only unique colors (not each weight variant)
  const uniqueColors = data.reduce((acc, item) => {
    if (!acc.find(existing => existing.color_name === item.color_name)) {
      acc.push(item);
    }
    return acc;
  }, []);

  return (
    <div>
      <div className='acp-sm-title acp-fw-500'>{category}</div>
      <div className='acp-clays acp-d-flex'>
        {
          uniqueColors.map((item, index) => (
            <ClayMd key={index} id={item.id_product_attribute} src={baseUrl+item.color_medium_image} name={item.color_name} onClickHandle={() => onClickHandle(item) }/>
          ))
        }
        <PaletListMdPrettier />
      </div>
    </div>
  );
}

export default  PaletListMd;